import React from "react";
import { Typography, Box, Button, Grid, Card, List, ListItem, ListItemText } from "@mui/material";
import TriangleBackground from "../components/layout/TriangleBackground";
import LogoIcon from "../assets/logo.png"; // your logo
import brandsimg from "../assets/images/brands.jpeg"
import Slider from "react-slick"; // make sure to install react-slick and slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import whovr from "../assets/images/whoweare.jpeg"
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CommuteIcon from '@mui/icons-material/Commute';
import SchoolIcon from '@mui/icons-material/School';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import HotelIcon from '@mui/icons-material/Hotel';
import SpeedIcon from '@mui/icons-material/Speed';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import AppsIcon from '@mui/icons-material/Apps';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/navigation";


import "./style.css"
// Example icons
import WebIcon from "@mui/icons-material/Web";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CloudIcon from "@mui/icons-material/Cloud";
import StorageIcon from "@mui/icons-material/Storage";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import careerimge from "../assets/images/careerimg.jpeg";
const Home = ({ mode }) => {
  const DColors = ["#FF69B4", "#35ca35", "#FFA500", "#00BFFF"]; // pink, green, orange, blue




  const textSegments = [
    { letter: "D", color: DColors[0] },
    { text: "iscover, " },
    { letter: "D", color: DColors[1] },
    { text: "esign, " },
    { letter: "D", color: DColors[2] },
    { text: "evelop and " },
    { letter: "D", color: DColors[3] },
    { text: "eliver the technology needs." },
  ];

  // Example services array
  const services = [
    {
      title: "Web Development",
      icon: <WebIcon fontSize="large" color="primary" />,
      points: ["Responsive websites", "Modern UI/UX", "SEO-friendly"],
    },
    {
      title: "Mobile Development",
      icon: <PhoneIphoneIcon fontSize="large" color="primary" />,
      points: ["iOS & Android apps", "Cross-platform", "Performance optimized"],
    },
    {
      title: "CDN Solutions",
      icon: <SpeedIcon fontSize="large" color="primary" />,
      description: "Accelerated performance through content delivery networks.",
      points: ["Multi CDN Migrations", "Global Delivery", "Caching Strategies"],
    },
    {
      title: "Cloud Computing",
      icon: <CloudIcon fontSize="large" color="primary" />,
      points: ["AWS, Azure, GCP", "Scalable infrastructure", "Serverless options"],
    },
    {
      title: "Middleware",
      icon: <StorageIcon fontSize="large" color="primary" />,
      points: ["Integration services", "APIs & messaging", "Data pipelines"],
    },
    {
      title: "GenAI",
      icon: <SmartToyIcon fontSize="large" color="primary" />,
      points: ["AI-powered solutions", "Automation", "Chatbots & NLP"],
    },
    {
      title: "Innovation Tech",
      icon: <LightbulbIcon fontSize="large" color="primary" />,
      description: "Explore bleeding-edge tech to future-proof your business.",
      points: ["AR/VR", "IoT Solutions", "Blockchain Use Cases"],
    },
    {
      title: "Enterprise App Development",
      icon: <AppsIcon fontSize="large" color="primary" />,
      description: "Large-scale app solutions for internal & external use.",
      points: ["CRM Systems", "ERP Integrations", "Data-Driven Dashboards"],
    },
  ];

  // Slider settings
  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }, // Add more granular breakpoint for smaller devices
    ],
  };


  return (
    <div>
      {/* === Hero Section with Triangle Background === */}
      <TriangleBackground mode={mode}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            px: 2,
            gap: 4,
            height: "100%",
          }}
        >
          {/* Content on the left */}
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: mode === "dark" ? "#ccc" : "#222",
              }}
            >
              We stick with 4Ds..
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: mode === "dark" ? "#fff" : "#000",
              }}
            >
              {textSegments.map((seg, idx) =>
                seg.letter ? (
                  <span key={idx} style={{ color: seg.color }}>
                    {seg.letter}
                  </span>
                ) : (
                  <span key={idx}>{seg.text}</span>
                )
              )}
            </Typography>

            <Typography
              variant="h6"
              className="fade-slide-text"
              sx={{ color: mode === "dark" ? "#ccc" : "#444" }}
            >
              One Stop Solution for Technology
            </Typography>
          </Box>

          {/* Logo on the right */}
          <Box
            component="img"
            src={LogoIcon}
            alt="Olyviatech Logo"
            className="spin-fade-logo"
            sx={{
              width: { xs: 120, sm: 150, md: 250 },
              height: "auto",
            }}
          />
        </Box>
      </TriangleBackground>

      {/* === Brand Section with Carousel === */}
      <section
        style={{
          padding: "60px 20px",
          backgroundColor: mode === "dark" ? "#111" : "#fafafa",
        }}
      >
        {/* Heading */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            mb: 4,
            textAlign: "center",
            color: mode === "dark" ? "#fff" : "#000",
          }}
        >
          {/* Brand we’ve worked with */}
          Who We Are ..?
        </Typography>
        {/* Carousel */}
        <Box
          sx={{
            maxWidth: 1200,
            mx: "auto",
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // stack on mobile
            alignItems: "stretch", // make carousel and text same height
            gap: { xs: 4, md: 6 },
          }}
        >
          <Box sx={{ width: { xs: "100%", md: "50%" }, minHeight: { xs: 180, sm: 220, md: 250 } }}>
            {/* <Slider
              dots={false}          // remove dots
              arrows={false}        // remove arrows
              infinite={true}       // loop continuously
              speed={500}           // transition speed
              slidesToShow={1}      // show one slide at a time
              slidesToScroll={1}    // scroll one at a time
              autoplay={true}       // auto-play
              autoplaySpeed={3000}  // every 3 seconds
              pauseOnHover={false}  // don't pause on hover
            >
              <Box component="img" src={brandsimg} alt="Brand 1" sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 2 }} />
              <Box component="img" src={brandsimg} alt="Brand 2" sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 2 }} />
    
            </Slider> */}
            <img src={whovr} style={{ width: "100%" }}></img>
          </Box>

          {/* Text */}
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: { xs: "center", md: "left" },
              px: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: mode === "dark" ? "#ccc" : "#333",
                lineHeight: 1.7,
                mb: 2,
              }}
            >
              We are a forward-thinking digital strategy consultancy, passionate about innovation, collaboration, and driving transformative digital experiences. With expertise across global brands, top consultancies, high-growth startups, Fortune 500 companies, and governments, we empower organizations to thrive in the digital age. Our mission is to accelerate digital transformation, unlocking powerful, lasting impact for our clients in today’s rapidly evolving tech landscape.
            </Typography>

            <Button
              component="a"
              href="/about"
              variant="text"
              sx={{ mt: 2, fontWeight: "bold", color: "#1976d2", alignSelf: { xs: "center", md: "flex-start" } }}
            >
              About Us →
            </Button>
          </Box>
        </Box>
      </section>



      {/* === Placeholder Sections === */}
      <section style={{ padding: "60px 20px", backgroundColor: mode === "dark" ? "#111" : "#fafafa" }}>
        <Box sx={{ mx: "auto", textAlign: "center" }}>
          {/* Heading */}
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, color: mode === "dark" ? "#fff" : "#000" }}>
            Our Services
          </Typography>

          {/* Button */}
          <Button
            component="a"
            href="/services"
            variant="text"
            sx={{ mt: 2, fontWeight: "bold", color: "#1976d2", alignSelf: { xs: "center", md: "flex-start" } }}
          >
            Go To Services →
          </Button>

          {/* Services Carousel */}
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={20}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            loop={true}
            pagination={{ clickable: true }}
            navigation={false}
            breakpoints={{
              320: { slidesPerView: 1 },
              600: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            style={{
              paddingBottom: "50px", // ensures pagination dots don't overlap cards
            }}
          >
            {services.map((service, idx) => (
              <SwiperSlide key={idx}>
                <Box sx={{ px: 1, width: "100%" }}>
                  <Card
                    sx={{
                      height: "250px",
                      borderRadius: 2,
                      boxShadow: 3,
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      margin: 2,
                      justifyContent: "center",
                      backgroundColor: mode === "dark" ? "#1a1a1a" : "#fff",
                    }}
                  >
                    {/* Icon */}
                    <Box sx={{ mb: 1 }}>
                      {React.cloneElement(service.icon, {
                        sx: { fontSize: 40, color: mode === "dark" ? "#4caf50" : "#FF69B4" },
                      })}
                    </Box>

                    {/* Title */}
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", mb: 1, textAlign: "center" }}
                    >
                      {service.title}
                    </Typography>

                    {/* Bullet points */}
                    <List dense sx={{ p: 0 }}>
                      {service.points.map((point, i) => (
                        <ListItem key={i} sx={{ display: "list-item", pl: 2 }}>
                          <ListItemText
                            primary={point}
                            sx={{
                              m: 0,
                              "& .MuiTypography-root": {
                                fontSize: "0.9rem",
                                color: mode === "dark" ? "#ccc" : "#555",
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Card>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>

        </Box>
      </section>

      {/* === CTA Section: Have a Question? === */}
      <section
        style={{
          position: "relative",
          padding: "120px 20px",
          backgroundColor: "#000", // force dark background for stars
          overflow: "hidden",
        }}
      >
        {/* Animated stars background */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `
        radial-gradient(white 1px, transparent 1px),
        radial-gradient(white 1px, transparent 1px)
      `,
            backgroundSize: "40px 40px",
            backgroundPosition: "0 0, 20px 20px",
            animation: "moveStars 60s linear infinite",
            opacity: 0.5,
            zIndex: 0,
          }}
        />

        {/* Foreground content */}
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            maxWidth: "800px",
            mx: "auto",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#fff",
              mb: 4,
            }}
          >
            Have a question? We're happy to help
          </Typography>

          <Button
            variant="contained"
            href="/contact"
            sx={{
              backgroundColor: "#4caf50",
              color: "#ffff",
              fontWeight: "bold",
              px: 5,
              py: 1.5,
              fontSize: "1rem",
              borderRadius: "8px",
              '&:hover': {
                backgroundColor: "#43a047",
              },
            }}
          >
            Contact Us
          </Button>
        </Box>
      </section>


      <section className="build-section">
        <div className="build-wrapper">
          <img
            src={careerimge} // replace with your image path
            alt="Building Future"
            className="build-image"
          />
          <div className="build-content">
            <h2>There is so much left to build</h2>
            <p>
              At Olyvia Tech, we work for the common good - within our organization and with other organizations around the world. We're building a future where data can be leveraged to serve people, create value and improve the quality of life.
            </p>
            <Button
              component="a"
              href="/careers"
              variant="text"
              className="build-button"
            >
              Go To Careers →
            </Button>
          </div>
        </div>
      </section>


      {/* === Industries Section === */}
      {/* === Industries Section === */}
      <section
        style={{
          position: "relative",
          padding: "100px 20px",
          backgroundColor: mode === "dark" ? "#0f0f0f" : "#fafafa",
          overflow: "hidden",
        }}
      >
        {/* Faded background logo */}
        <Box
          component="img"
          src={LogoIcon}
          alt="Background Logo"
          sx={{
            position: "absolute",
            top: "50%",
            left: "30%",
            transform: "translate(-50%, -50%)",
            width: { xs: "300px", md: "900px" },
            opacity: 0.5,
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        {/* Content wrapper */}
        <Box sx={{ position: "relative", zIndex: 2, maxWidth: "1400px", mx: "auto" }}>
          {/* Title */}
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              mb: 6,
              color: mode === "dark" ? "#fff" : "#000",
            }}
          >
            Industries We Serve
          </Typography>

          {/* Cards Grid */}
          <Grid container spacing={4}>
            {[
              { title: "Healthcare", icon: <LocalHospitalIcon sx={{ fontSize: 55 }} /> },
              { title: "Finance", icon: <AttachMoneyIcon sx={{ fontSize: 55 }} /> },
              { title: "Retail", icon: <StorefrontIcon sx={{ fontSize: 55 }} /> },
              { title: "Transport", icon: <CommuteIcon sx={{ fontSize: 55 }} /> },
              { title: "Education", icon: <SchoolIcon sx={{ fontSize: 55 }} /> },
              { title: "Telecom", icon: <PhoneAndroidIcon sx={{ fontSize: 55 }} /> },
              { title: "Fashion", icon: <CheckroomIcon sx={{ fontSize: 55 }} /> },
              { title: "Hospitality", icon: <HotelIcon sx={{ fontSize: 55 }} /> },
            ].map((industry, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    py: 6,
                    px: 4,
                    minHeight: 240,
                    textAlign: "center",
                    backgroundColor: mode === "dark" ? "#1a1a1a" : "#fff",
                    color: mode === "dark" ? "#fff" : "#000",
                    borderRadius: 4,
                    boxShadow: 4,
                    height: "100%",
                    transition: "transform 0.3s ease-in-out",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    "&:hover": {
                      transform: "translateY(-6px)",
                    },
                  }}
                >
                  <Box sx={{ color: "#4caf50", mb: 2 }}>{industry.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "1.15rem" }}>
                    {industry.title}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </section>



      {/* <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Careers
        </Typography>
        <Typography variant="body1">[ Add careers info here ]</Typography>
      </section>

      <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Contact Us
        </Typography>
        <Typography variant="body1">[ Add contact form here ]</Typography>
      </section> */}
    </div>
  );
};

export default Home;
